<template>
  <div>
    <v-tabs fixed-tabs v-model="tabs">
      <v-tab :value="0">GL Account No. Information</v-tab>
      <v-tab-item>
        <v-card flat>
          <v-card-text>
            <v-container fluid grid-list-sm>
              <v-layout row wrap>
                <v-flex xs4>
                  <v-subheader class="queryLabel">Branch</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{ glacctNoForm.branch }} - {{ glacctNoForm.brnDesc }}</span>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs4>
                  <v-subheader class="queryLabel">GL Account No.</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{ glacctNoForm.glacctNo }}</span>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs4>
                  <v-subheader class="queryLabel">Fund</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{ glacctNoForm.fund }} - {{ glacctNoForm.fundDesc }}</span>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs4>
                  <v-subheader class="queryLabel">Account No. Suffix</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{ glacctNoForm.acctNoSfx }} - {{ glacctNoForm.acctNoSfxDesc }}</span>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs4>
                  <v-subheader class="queryLabel">Description</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{ glacctNoForm.description }}</span>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs4>
                  <v-subheader class="queryLabel">Currency</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{ glacctNoForm.curr }} - {{ glacctNoForm.currDesc }}</span>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs4>
                  <v-subheader class="queryLabel">Parent Account</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{ glacctNoForm.parentAcctNo }} {{ glacctNoForm.parentFund }} {{ glacctNoForm.parentAcctNoSfx }}</span>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import { expandURI } from '@/utils/ajax'
export default {
  data() {
    return {
      tabs: 0,
      glacctNoForm: {
        branch: null,
        brnDesc: null,
        glacctNo: null,
        fund: null,
        fundDesc: null,
        acctNoSfx: null,
        acctNoSfxDesc: null,
        description: null,
        curr: null,
        currDesc: null,
        parentAcctNo: null,
        parentFund: null,
        parentAcctNoSfx: null
      }
    }
  },
  mounted() {
    this.doInit()
  },
  methods: {
    async doInit() {
      if (this.newGLAcctNo) {
        this.glacctNoForm.branch = null
        this.glacctNoForm.brnDesc = null
        this.glacctNoForm.glacctNo = null
        this.glacctNoForm.fund = null
        this.glacctNoForm.fundDesc = null
        this.glacctNoForm.acctNoSfx = null
        this.glacctNoForm.acctNoSfxDesc = null
        this.glacctNoForm.description = null
        this.glacctNoForm.curr = null
        this.glacctNoForm.currDesc = null
        this.glacctNoForm.parentAcctNo = null
        this.glacctNoForm.parentFund = null
        this.glacctNoForm.parentAcctNoSfx = null
      } else {
        this.fetchData()
      }
    },
    async fetchData() {
      const apiURI = this.menu.glacctNo
      if (apiURI) {
        try {
          const expand = this.glacctNoId
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.glacctNoForm.branch = data.glacctNo.branch
            if (data.branch) {
              this.glacctNoForm.brnDesc = data.branch.brnDesc
            }
            this.glacctNoForm.glacctNo = data.glacctNo.glacctNo
            this.glacctNoForm.fund = data.glacctNo.fund
            if (data.fund) {
              this.glacctNoForm.fundDesc = data.fund.fundDesc
            }
            this.glacctNoForm.acctNoSfx = data.glacctNo.acctNoSfx
            if (data.acctNoSfx) {
              this.glacctNoForm.acctNoSfxDesc = data.acctNoSfx.description
            }
            this.glacctNoForm.description = data.glacctNo.description
            this.glacctNoForm.curr = data.glacctNo.curr
            if (data.curr) {
              this.glacctNoForm.currDesc = data.curr.currDesc
            }
            this.glacctNoForm.parentAcctNo = data.glacctNo.parentAcctNo
            this.glacctNoForm.parentFund = data.glacctNo.parentFund
            this.glacctNoForm.parentAcctNoSfx = data.glacctNo.parentAcctNoSfx
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    }
  },
  computed: {
    menu() {
      return this.$store.state.glAcctParam.menu
    },
    glacctNoId() {
      return this.$store.state.glAcctParam.glAcctNo.glAcctNoId
    },
    newGLAcctNo() {
      return this.glacctNoId.branch === 'new' && this.glacctNoId.glacctNo === 'new'
    },
    updateCount() {
      return this.updateCnt
    }
  },
  watch: {
    updateCount(value) {
      this.doInit()
    }
  },
  props: ['updateCnt']
}
</script>

<style>
</style>
